import { Action } from '@ngrx/store';

export enum EventMapActionTypes {
  GetEventMaps = '[EventMap] Get EventMaps',
  LoadEventMaps = '[EventMap] Load EventMaps',
  ChangeLanguageEventMaps = '[EventMap] Change Language EventMaps',
  GetEventMapsFail = '[EventMap] Get EventMaps Fail'
}

export class GetEventMaps implements Action {
  readonly type = EventMapActionTypes.GetEventMaps;
}

export class LoadEventMaps implements Action {
  readonly type = EventMapActionTypes.LoadEventMaps;
  constructor(public payload: any = null) {}
}

export class ChangeLanguageEventMaps implements Action {
  readonly type = EventMapActionTypes.ChangeLanguageEventMaps;
}

export class GetEventMapsFail implements Action {
  readonly type = EventMapActionTypes.GetEventMapsFail;
}


export type EventMapActions = LoadEventMaps
  | GetEventMaps
  | ChangeLanguageEventMaps
  | GetEventMapsFail;
